import { render, staticRenderFns } from "./customer-case-detail.vue?vue&type=template&id=8bc0b3ec&"
import script from "./customer-case-detail.js?vue&type=script&lang=js&"
export * from "./customer-case-detail.js?vue&type=script&lang=js&"
import style0 from "./customer-case-detail.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports